import { keepPreviousData, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type React from "react";
import ResetQueryProvider from "../error/ResetQueryProvider.tsx";

// create `queryClient` to use throughout the app
export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: Number.POSITIVE_INFINITY,
			placeholderData: keepPreviousData,
			experimental_prefetchInRender: true,
		},
	},
});
/**
 * Query provider for the app
 * preferably if you need to use `queryClient` use exported one from this file
 * using:
 * ```typescript
 * 	import {queryClient} from "path/to/SzQueryClientProvider";
 * ```
 * and then use it as needed as described in [TanStack docs](https://tanstack.com/query/latest/docs/reference/QueryClient)
 *
 * # though the same `queryClient` is passed to the router context in `RouterProvider`
 *
 * @param children
 * @constructor
 */
const SzQueryClientProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<QueryClientProvider client={queryClient}>
			<ResetQueryProvider>{children}</ResetQueryProvider>
		</QueryClientProvider>
	);
};

export default SzQueryClientProvider;
